// search-layer/stores/search.ui-store.ts

import { defineStore } from 'pinia'
import { ref, computed } from 'vue'

export const useSearchUIStore = defineStore('search-ui', () => {
  // ===== STATE =====

  const query = ref<string>('')

  // ===== COMPUTED =====

  const hasActiveSearch = computed(() => query.value.trim().length > 0)

  // ===== ACTIONS =====

  const setQuery = (newQuery: string) => {
    query.value = newQuery
  }

  const clearQuery = () => {
    query.value = ''
  }

  return {
    // State (as computed for reactivity)
    query: computed(() => query.value),

    // Computed
    hasActiveSearch,

    // Actions
    setQuery,
    clearQuery,
  }
})
